<template>
  <div>
    <DeleteModal
      modal-id="modal-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('bloodBank.add-blood-transfusion')
          : $t('bloodBank.edit-blood-transfusion')
      "
    >
      <b-card-text>
        <b-row>
          <b-col
            md="12"
            style="font-weight: bold"
          >
            سس
            <AutoComplete
              v-model="EditForm.patient_card_id"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :is-relational="true"
              :other-query="`include=patient&filter[is_active]=true`"
              keyword="patient"
            />
            <p class="text-danger mt-1">
              {{ errorForm.patient_card_id }}
            </p>
          </b-col>
          <b-col
            md="12"
            style="font-weight: bold"
          >
            <AutoComplete
              v-model="EditForm.blood_transfusion_type_id"
              :label="$t('bloodBank.blood-transfusion-type')"
              :placeholder="$t('bloodBank.blood-transfusion-type')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="bloodTransfusionTypes"
              text-title="name"
              keyword="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.blood_transfusion_type_id }}
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            md="4"
            style="font-weight: bold"
          >
            <b-form-group
              :label="$t('bloodBank.patient-abo')"
              label-for="patient_abo"
            >
              <v-select
                v-model="EditForm.patient_abo"
                :options="aboOptions"
                placeholder="A, B, AB, O"
              />
              <p class="text-danger mt-1">
                {{ errorForm.patient_abo }}
              </p>
            </b-form-group>
          </b-col>

          <b-col
            md="4"
            style="font-weight: bold"
          >
            <b-form-group
              :label="$t('bloodBank.patient-rh')"
              label-for="patient_rh"
            >
              <v-select
                v-model="EditForm.patient_rh"
                :options="rhOptions"
                placeholder="Positive, Negative"
              />
              <p class="text-danger mt-1">
                {{ errorForm.patient_rh }}
              </p>
            </b-form-group>
          </b-col>

          <b-col
            md="4"
            style="font-weight: bold"
          >
            <b-form-group
              :label="$t('bloodBank.number-of-units')"
              label-for="number_of_units"
            >
              <b-form-input
                v-model="EditForm.number_of_units"
                type="number"
                :placeholder="$t('bloodBank.number-of-units')"
              />
              <p class="text-danger mt-1">
                {{ errorForm.number_of_units }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <b-row>
                    <b-col md="12">
                        <b-form-group :label="$t('bloodBank.inserted-at')" label-for="inserted_at">
                            <datepicker v-model="EditForm.inserted_at" :calendar-button="true" :clear-button="true"
                                :bootstrap-styling="true" class="datebtn2" placeholder="YYYY-MM-DD"></datepicker>
                        </b-form-group>
                        <p class="text-danger mt-1">{{ errorForm.inserted_at }}</p>
                    </b-col>
                </b-row> -->
        <b-row />
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          ref="button"
          variant="primary"
          class="m-0"
          :disabled="loading"
          block
          @click="submitItem"
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner
            v-else
            small
          />
        </b-button>
      </template>
    </b-modal>

    <b-card
      no-body
      class="compact-card main-padding"
    >
      <div class="compact-container">
        <!-- Header with title and view toggle -->
        <b-row class="compact-row">
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center compact-header"
          >
            <h2 class="mb-0 compact-title">
              {{ $t("bloodBank.blood-transfusions-table") }}
            </h2>
            <div
              class="d-flex align-items-center gap-2"
              style="gap: 10px"
            >
              <div class="view-toggle-buttons">
                <b-button-group size="sm">
                  <b-button
                    :variant="
                      viewMode === 'list' ? 'primary' : 'outline-primary'
                    "
                    size="sm"
                    @click="viewMode = 'list'"
                  >
                    <feather-icon
                      icon="ListIcon"
                      size="14"
                    />
                    {{ $t("common.table") }}
                  </b-button>
                  <b-button
                    :variant="
                      viewMode === 'card' ? 'primary' : 'outline-primary'
                    "
                    size="sm"
                    @click="viewMode = 'card'"
                  >
                    <feather-icon
                      icon="GridIcon"
                      size="14"
                    />
                    {{ $t("common.card") }}
                  </b-button>
                </b-button-group>
              </div>
              <b-button
                variant="primary"
                size="sm"
                @click="show(EditForm, 'create')"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="14"
                />
                {{ $t("bloodBank.add-blood-transfusions") }}
              </b-button>
            </div>
          </b-col>
        </b-row>

        <!-- Filters Section -->
        <b-row class="compact-row">
          <b-col md="12">
            <b-button
              v-b-toggle.filter-collapse
              variant="outline-primary"
              size="sm"
              class="compact-filter-toggle"
            >
              <feather-icon
                icon="FilterIcon"
                size="14"
                class="mr-50"
              />
              <span class="when-closed mr-50">{{
                $t("common.show-filters")
              }}</span>
              <span class="when-open mr-50">{{
                $t("common.hide-filters")
              }}</span>
              <feather-icon
                icon="ChevronDownIcon"
                size="14"
                class="when-closed"
              />
              <feather-icon
                icon="ChevronUpIcon"
                size="14"
                class="when-open"
              />
            </b-button>
          </b-col>
        </b-row>

        <b-collapse id="filter-collapse">
          <div class="compact-filters-section">
            <b-row class="compact-row compact-filters">
              <b-col
                md="3"
                cols="12"
                class="compact-col"
              >
                <AutoComplete
                  v-model="patient_card_id"
                  :label="$t('common.Patient Card')"
                  :placeholder="$t('common.Patient Card')"
                  param-query="patient.name"
                  :serializer="(val) => val.id"
                  endpoint="patientCard"
                  text-title="patient.name"
                  :is-relational="true"
                  :other-query="`include=patient&filter[is_active]=true`"
                  keyword="patient"
                />
              </b-col>
              <b-col
                md="3"
                cols="6"
                class="compact-col"
              >
                <AutoComplete
                  v-model="blood_transfusion_type_id"
                  :label="$t('bloodBank.blood-transfusion-type')"
                  :placeholder="$t('bloodBank.blood-transfusion-type')"
                  param-query="name"
                  :serializer="(val) => val.id"
                  endpoint="bloodTransfusionTypes"
                  text-title="name"
                  keyword="name"
                />
              </b-col>
              <b-col
                md="2"
                cols="6"
                class="compact-col"
              >
                <b-form-group
                  :label="$t('bloodBank.patient-abo')"
                  label-for="patient_abo"
                  class="compact-form-group"
                >
                  <v-select
                    v-model="patient_abo"
                    :options="aboOptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="A, B, AB, O"
                    class="compact-input"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                cols="6"
                class="compact-col"
              >
                <b-form-group
                  :label="$t('bloodBank.patient-rh')"
                  label-for="patient_rh"
                  class="compact-form-group"
                >
                  <v-select
                    v-model="patient_rh"
                    :options="rhOptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="Positive, Negative"
                    class="compact-input"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                cols="6"
                class="compact-col"
              >
                <b-form-group
                  :label="$t('bloodBank.search-from-to-by')"
                  label-for="searchDate"
                  class="compact-form-group"
                >
                  <v-select
                    v-model="searchDate"
                    :options="searchFromToBy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="label"
                    :reduce="(option) => option"
                    :placeholder="$t('bloodBank.search-from-to-by')"
                    class="compact-input"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row
              v-if="selectedSearch && selectedSearch.key === 'created_at'"
              class="compact-row compact-filters"
            >
              <b-col
                md="6"
                cols="12"
                class="compact-col"
              >
                <b-form-group
                  :label="`${selectedSearch.label || ''} ${$t('common.from')}`"
                  label-for="from_date"
                  class="compact-form-group"
                >
                  <b-form-datepicker
                    v-model="from_date"
                    :placeholder="$t('common.select-date')"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                    locale="en"
                    class="dark-datepicker compact-input"
                    today-button
                    reset-button
                    close-button
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                cols="12"
                class="compact-col"
              >
                <b-form-group
                  :label="`${selectedSearch.label || ''} ${$t('common.to')}`"
                  label-for="to_date"
                  class="compact-form-group"
                >
                  <b-form-datepicker
                    v-model="to_date"
                    :placeholder="$t('common.select-date')"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                    locale="en"
                    class="dark-datepicker compact-input"
                    today-button
                    reset-button
                    close-button
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-collapse>

        <!-- Content Section -->
        <b-row class="compact-content-row">
          <b-col>
            <!-- List View -->
            <b-table
              v-if="viewMode === 'list' && !loading"
              :items="data"
              responsive
              :fields="bloodBottleTableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative compact-table"
            >
              <template #cell(patient_card.patient.name)="data">
                <p
                  class="text-nowrap"
                  style="font-size: 1.2rem; font-weight: bold"
                >
                  {{
                    getNestedProperty(data.item, "patient_card.patient.name")
                  }}
                </p>
              </template>

              <template #cell(patient_abo)="data">
                <p style="font-size: 1.2rem; font-weight: bold">
                  {{ data.item.patient_abo }}
                </p>
              </template>
              <template #cell(patient_rh)="data">
                <p style="font-size: 1.2rem; font-weight: bold">
                  {{ data.item.patient_rh }}
                </p>
              </template>
              <template #cell(number_of_units)="data">
                <p style="font-size: 1.2rem; font-weight: bold">
                  {{ data.item.number_of_units }}
                </p>
              </template>

              <template #cell(blood_bottles.bottle_identifier)="data">
                <ol>
                  <li
                    v-for="bottle in data.item.blood_bottles"
                    :key="bottle.id"
                    class="mb-1"
                  >
                    <b-badge
                      variant="secondary"
                      style="font-size: 1rem; font-weight: bold; color: #000"
                    >{{ bottle.bottle_identifier }}</b-badge>
                  </li>
                </ol>
              </template>

              <template #cell(blood_compatibilities.final_result)="data">
                <ol>
                  <li
                    v-for="result in data.item.blood_compatibilities"
                    :key="result.id"
                    class="mb-1"
                  >
                    <b-badge
                      :variant="
                        result.final_result === 'compatible'
                          ? 'success'
                          : 'danger'
                      "
                      style="font-size: 1rem; color: #000"
                    >{{ result.final_result }}</b-badge>
                  </li>
                </ol>
              </template>

              <template #cell(blood_transfusion_type_id)="data">
                <p style="font-size: 1.2rem; font-weight: bold">
                  {{ getTransfusionType(data.item.blood_transfusion_type_id) }}
                </p>
              </template>
              <template #cell(created_at)="data">
                <p
                  style="
                    font-size: 1.2rem;
                    font-weight: bold;
                    text-wrap: nowrap;
                  "
                >
                  {{ data.item.created_at }}
                </p>
              </template>

              <template #cell(sample_matching)="data">
                <b-button
                  size="sm"
                  pill
                  variant="outline-secondary"
                  @click="
                    $router.push({
                      name: 'blood-compatibilities',
                      params: {
                        blood_transfusion_id: data.item.id,
                        patient_name: getNestedProperty(
                          data.item,
                          'patient_card.patient.name'
                        ),
                        patient_abo: data.item.patient_abo,
                        patient_rh: data.item.patient_rh,
                        isSho: false,
                      },
                    })
                  "
                >
                  {{ $t("bloodBank.sample-matching") }}
                </b-button>
              </template>

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-dropdown
                  right
                  variant="outline-secondary"
                  size="sm"
                  class="no-nav"
                >
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" />
                  </template>

                  <b-dropdown-item
                    v-if="
                      $store.state.app.permissions.includes(
                        'get-bloodTransfusion'
                      )
                    "
                    @click.stop="show(data.item)"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="14"
                      class="mr-50"
                    />
                    {{ $t("common.edit") }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      $store.state.app.permissions.includes(
                        'get-bloodTransfusion'
                      )
                    "
                    class="text-danger"
                    @click.stop="deleteModel(data.item)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      size="14"
                      class="mr-50"
                    />
                    {{ $t("common.delete") }}
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <!-- Card View -->
            <div
              v-else-if="viewMode === 'card' && !loading"
              class="transfusion-cards-container"
            >
              <!-- Empty State Placeholder -->
              <div
                v-if="data.length === 0"
                class="empty-state-card"
              >
                <b-card class="text-center empty-placeholder-card">
                  <div class="empty-state-content">
                    <feather-icon
                      icon="DropletIcon"
                      size="48"
                      class="empty-icon"
                    />
                    <h5 class="mt-2 mb-1">
                      {{ $t("common.no-results") }}
                    </h5>
                    <p class="text-muted mb-0">
                      {{ $t("common.no-matching-results-found") }}
                    </p>
                  </div>
                </b-card>
              </div>
              <!-- Blood Transfusion Cards -->
              <b-row v-else>
                <b-col
                  v-for="transfusion in data"
                  :key="transfusion.id"
                  cols="12"
                  md="6"
                  lg="4"
                  class="compact-card-col"
                >
                  <b-card
                    class="transfusion-card h-100 compact-transfusion-card"
                  >
                    <div class="card-body-card">
                      <div class="compact-card-body">
                        <div class="compact-card-header">
                          <div
                            class="d-flex justify-content-between align-items-start mb-1"
                          >
                            <h6
                              class="mb-0 font-weight-bold text-primary compact-transfusion-id"
                            >
                              {{
                                getNestedProperty(
                                  transfusion,
                                  "patient_card.patient.name"
                                ) || "-"
                              }}
                            </h6>
                          </div>
                        </div>

                        <div class="transfusion-info-item compact-info-item">
                          <span
                            class="info-label"
                          >{{ $t("bloodBank.blood-transfusion-type") }}:</span>
                          <span class="info-value font-weight-bold">{{
                            getTransfusionType(
                              transfusion.blood_transfusion_type_id
                            ) || "-"
                          }}</span>
                        </div>

                        <div class="transfusion-info-item compact-info-item">
                          <span
                            class="info-label"
                          >{{ $t("bloodBank.patient-abo") }}:</span>
                          <span class="info-value font-weight-bold">{{
                            transfusion.patient_abo || "-"
                          }}</span>
                        </div>

                        <div class="transfusion-info-item compact-info-item">
                          <span
                            class="info-label"
                          >{{ $t("bloodBank.patient-rh") }}:</span>
                          <span class="info-value font-weight-bold">{{
                            transfusion.patient_rh || "-"
                          }}</span>
                        </div>

                        <div class="transfusion-info-item compact-info-item">
                          <span
                            class="info-label"
                          >{{ $t("bloodBank.number-of-units") }}:</span>
                          <span class="info-value">{{
                            transfusion.number_of_units || "-"
                          }}</span>
                        </div>

                        <div
                          v-if="
                            transfusion.blood_bottles &&
                              transfusion.blood_bottles.length > 0
                          "
                          class="transfusion-info-item compact-info-item"
                        >
                          <span
                            class="info-label"
                          >{{ $t("bloodBank.bottle-identifier") }}:</span>
                          <div class="info-value">
                            <b-badge
                              v-for="bottle in transfusion.blood_bottles"
                              :key="bottle.id"
                              variant="secondary"
                              class="compact-badge mr-1 mb-1"
                            >
                              {{ bottle.bottle_identifier }}
                            </b-badge>
                          </div>
                        </div>

                        <div
                          v-if="
                            transfusion.blood_compatibilities &&
                              transfusion.blood_compatibilities.length > 0
                          "
                          class="transfusion-info-item compact-info-item"
                        >
                          <span
                            class="info-label"
                          >{{ $t("bloodBank.final-result") }}:</span>
                          <div class="info-value">
                            <b-badge
                              v-for="result in transfusion.blood_compatibilities"
                              :key="result.id"
                              :variant="
                                result.final_result === 'compatible'
                                  ? 'success'
                                  : 'danger'
                              "
                              class="compact-badge mr-1 mb-1"
                            >
                              {{ result.final_result }}
                            </b-badge>
                          </div>
                        </div>

                        <div class="transfusion-info-item compact-info-item">
                          <span
                            class="info-label"
                          >{{ $t("common.created-at") }}:</span>
                          <span class="info-value">{{
                            transfusion.created_at || "-"
                          }}</span>
                        </div>
                      </div>

                      <div class="compact-card-footer">
                        <b-button
                          size="sm"
                          pill
                          variant="outline-secondary"
                          class="compact-action-button"
                          @click.stop="
                            $router.push({
                              name: 'blood-compatibilities',
                              params: {
                                blood_transfusion_id: transfusion.id,
                                patient_name: getNestedProperty(
                                  transfusion,
                                  'patient_card.patient.name'
                                ),
                                patient_abo: transfusion.patient_abo,
                                patient_rh: transfusion.patient_rh,
                                isSho: false,
                              },
                            })
                          "
                        >
                          <feather-icon
                            icon="ActivityIcon"
                            size="14"
                          />
                          {{ $t("bloodBank.sample-matching") }}
                        </b-button>
                        <b-dropdown
                          right
                          variant="outline-secondary"
                          size="sm"
                          class="compact-action-button"
                        >
                          <template #button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="14"
                            />
                          </template>
                          <b-dropdown-item
                            v-if="
                              $store.state.app.permissions.includes(
                                'get-bloodTransfusion'
                              )
                            "
                            @click="show(transfusion)"
                          >
                            <feather-icon
                              icon="EditIcon"
                              size="14"
                              class="mr-50"
                            />
                            {{ $t("common.edit") }}
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="
                              $store.state.app.permissions.includes(
                                'get-bloodTransfusion'
                              )
                            "
                            class="text-danger"
                            @click="deleteModel(transfusion)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                              size="14"
                              class="mr-50"
                            />
                            {{ $t("common.delete") }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <!-- Loading State -->
            <div
              v-if="loading"
              class="text-center compact-loading"
            >
              <b-spinner label="Loading..." />
              <p class="mt-1 text-muted compact-loading-text">
                {{ $t("common.loading") }}
              </p>
            </div>
          </b-col>
        </b-row>

        <!-- Pagination -->
        <div
          v-if="dataCount > 0"
          class="compact-pagination"
        >
          <b-row class="compact-pagination-row">
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start compact-pagination-info"
            >
              <span class="text-muted compact-pagination-text">
                {{ $t("common.showing") }} {{ (page - 1) * take + 1 }}
                {{ $t("common.to") }} {{ Math.min(page * take, dataCount) }}
                {{ $t("common.of") }} {{ dataCount }}
              </span>
            </b-col>
            <!-- Pagination Controls -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                size="sm"
                class="mb-0 compact-pagination-controls"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="16"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="16"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <IVF
      :data="data"
      type="Hospital"
    />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
  BCollapse,
  VBToggle,
  BButtonGroup,
  BCardBody,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuePhoneNumberInput, { async } from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import Datepicker from 'vuejs-datepicker'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import permissionChecker from '@/mixins/permissionChecker'
import DeleteModal from '@/components/modals/DeleteModal.vue'
import axios from 'axios'

const IVF = () => import('@/components/printables/IVF.vue')
const Doctor = () => import('@/components/printables/Doctor.vue')
const AutoComplete = () => import('@/components/common/AutoComplete.vue')
export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    DeleteModal,
    BFormCheckbox,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    Doctor,
    AutoComplete,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    BCollapse,
    BButtonGroup,
    BCardBody,
  },
  mixins: [permissionChecker],
  data() {
    return {
      take: 15,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: '',
        patient_abo: '',
        patient_rh: '',
        blood_transfusion_type_id: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        patient_card_id: '',
        patient_abo: '',
        patient_rh: '',
        blood_transfusion_type_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      bloodBottleTableColumns: [
        {
          key: 'patient_card.patient.name',
          sortable: true,
          label: this.$t('bloodBank.patient-name'),
        },
        {
          key: 'blood_transfusion_type_id',
          sortable: true,
          label: this.$t('bloodBank.blood-transfusion-type'),
        },
        {
          key: 'patient_abo',
          sortable: true,
          label: this.$t('bloodBank.patient-abo'),
        },
        {
          key: 'patient_rh',
          sortable: true,
          label: this.$t('bloodBank.patient-rh'),
        },

        {
          key: 'number_of_units',
          sortable: true,
          label: this.$t('bloodBank.number-of-units'),
        },
        {
          key: 'blood_bottles.bottle_identifier',
          sortable: true,
          label: this.$t('bloodBank.bottle-identifier'),
        },
        {
          key: 'blood_compatibilities.final_result',
          sortable: true,
          label: this.$t('bloodBank.final-result'),
        },
        {
          key: 'sample_matching',
          sortable: true,
          label: this.$t('bloodBank.sample-matching'),
        },

        {
          key: 'Actions',
          label: this.$t('common.actions'),
          thStyle: { width: '150px' },
        },
        {
          key: 'created_at',
          sortable: true,
          label: this.$t('common.created-at'),
        },
      ],

      aboOptions: ['A', 'B', 'AB', 'O'],
      rhOptions: ['Positive', 'Negative'],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: 'IVF',
      },

      abo: '',
      rh: '',
      production_date: '',
      expiration_date: '',
      bottle_identifier: '',
      inserted_at: '',
      searchFromToBy: [
        {
          key: 'created_at',
          label: this.$t('bloodBank.created_at'),
          from: 'created_at-ge',
          to: 'created_at-le',
        },
      ].map(item => ({
        ...item,
        value: item,
      })),
      statusOptions: ['available', 'dispensed'],
      searchDate: '',
      selectedSearch: '',
      from_date: '',
      to_date: '',
      status: '',
      from_value: '',
      to_value: '',
      blood_transfusion_type_id: '',
      patient_card_id: '',
      patient_abo: '',
      patient_rh: '',
      number_of_units: '',
      room_temperature: '',
      incubator_temperature: '',
      transfusionTypes: [],
      viewMode: localStorage.getItem('bloodTransfusionsView') || 'card',
      isMounted: false,
    }
  },
  watch: {
    page() {
      this.getBloodTransfusions()
    },
    searchDate(newVal) {
      this.from_date = ''
      this.from_value = ''
      this.to_date = ''
      this.to_value = ''
      this.selectedSearch = newVal || ''
      if (this.isMounted) {
        this.getBloodTransfusions()
      }
    },
    patient_card_id() {
      if (this.isMounted) {
        this.getBloodTransfusions()
      }
    },
    blood_transfusion_type_id() {
      if (this.isMounted) {
        this.getBloodTransfusions()
      }
    },
    patient_abo() {
      if (this.isMounted) {
        this.getBloodTransfusions()
      }
    },
    patient_rh() {
      if (this.isMounted) {
        this.getBloodTransfusions()
      }
    },
    from_date() {
      if (this.isMounted && this.selectedSearch) {
        this.getBloodTransfusions()
      }
    },
    to_date() {
      if (this.isMounted && this.selectedSearch) {
        this.getBloodTransfusions()
      }
    },
    viewMode(newVal) {
      localStorage.setItem('bloodTransfusionsView', newVal)
    },
  },
  mounted() {
    this.getTransfusionTypeList()
    this.getBloodTransfusions()
    this.isMounted = true
  },
  methods: {
    async getTransfusionTypeList() {
      await this.getList('/bloodTransfusionTypes')
      this.transfusionTypes = this.all_data.data
      console.log('this.transfusionTypes', this.transfusionTypes)
    },
    getNestedProperty(obj, path, defaultValue = 'N/A') {
      const result = path
        .split('.')
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj,
        )
      // console.log("result", result);
      return result
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate)
      const year = date.getFullYear()
      let month = `${date.getMonth() + 1}`
      let day = `${date.getDate()}`

      if (month.length < 2) month = `0${month}`
      if (day.length < 2) day = `0${day}`

      return `${year}-${month}-${day}`
    },
    show(item, mode) {
      console.log('item', item)
      if (mode === 'create') {
        this.createMode = true
        this.EditForm = {
          _method: 'POST',
        }
      } else {
        this.createMode = false
        this.EditForm.id = item.id
        this.EditForm.patient_card_id = item.patient_card_id
        this.EditForm.patient_abo = item.patient_abo
        this.EditForm.patient_rh = item.patient_rh
        this.EditForm.blood_transfusion_type_id = item.blood_transfusion_type_id
        this.EditForm.number_of_units = item.number_of_units

        this.EditForm._method = 'PUT'
      }
      this.$bvModal.show('modal-edit')
    },
    async getBloodTransfusions() {
      this.loading = true
      // check if there are any null value in the obj we sending

      const requestTake = this.selectedSearch
        && (this.from_date || this.to_date || this.from_value || this.to_value)
        ? 1000
        : 15
      this.take = requestTake

      let url = `/bloodTransfusions?page=${this.page}&take=${requestTake}&sort=-id&include[]=bloodBottles&include[]=bloodCompatibilities&include[]=patientCard&include[]=transfusionType`

      if (this.patient_card_id) {
        url += `&filter[patient_card_id]=${this.patient_card_id}`
      }
      if (this.patient_abo) {
        url += `&filter[patient_abo]=${this.patient_abo}`
      }
      if (this.patient_rh) {
        url += `&filter[patient_rh]=${this.patient_rh}`
      }
      if (this.blood_transfusion_type_id) {
        url += `&filter[blood_transfusion_type_id]=${this.blood_transfusion_type_id}`
      }

      if (this.from_date && this.selectedSearch && this.selectedSearch.from) {
        url += `&filter[${this.selectedSearch.from}]=${this.formatDate(
          this.from_date,
        )}`
      }
      if (this.to_date && this.selectedSearch && this.selectedSearch.to) {
        url += `&filter[${this.selectedSearch.to}]=${this.formatDate(
          this.to_date,
        )}`
      }

      if (this.from_value && this.selectedSearch && this.selectedSearch.from) {
        url += `&filter[${this.selectedSearch.from}]=${this.from_value}`
      }
      if (this.to_value && this.selectedSearch && this.selectedSearch.to) {
        url += `&filter[${this.selectedSearch.to}]=${this.to_value}`
      }

      await this.getList(url)
      this.dataCount = this.all_data.total
      this.data = this.all_data.data
      this.loading = false
      // console.log("this.data", this.data);
    },

    deleteModel(item) {
      this.deleteForm = item
      this.$bvModal.show('modal-delete')
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/bloodTransfusions/${this.deleteForm.id}`)
        .then(response => {
          this.getBloodTransfusions()

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text:
                `deleted ${
                  this.deleteForm.bottle_identifier
                } successfully`,
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: `Error deleting ${this.deleteForm.bottle_identifier}`,
            },
          })
        })
    },

    submitItem() {
      let count = 0
      this.loading = true
      this.errorForm.patient_card_id = ''
      this.errorForm.patient_abo = ''
      this.errorForm.patient_rh = ''
      this.errorForm.blood_transfusion_type_id = ''
      for (const item in this.errorForm) {
        this.errorForm[item] = ''
        if (this.EditForm[item] == '' || this.EditForm[item] == null) delete this.EditForm[item]
      }

      if (!this.EditForm.patient_card_id) {
        count++
        this.errorForm.patient_card_id = 'The patient card id field is required.'
      }
      if (!this.EditForm.patient_abo) {
        count++
        this.errorForm.patient_abo = 'The ABO field is required.'
      }
      if (!this.EditForm.patient_rh) {
        count++
        this.errorForm.patient_rh = 'The RH field is required.'
      }
      if (!this.EditForm.blood_transfusion_type_id) {
        count++
        this.errorForm.blood_transfusion_type_id = 'The blood transfusion type field is required.'
      }

      console.log('editForm', this.EditForm)
      if (count > 0) {
        this.loading = false
        return false
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
        (this.params.path = '/bloodTransfusions'),
        this.$store
          .dispatch('create', this.params)
          .then(response => {
            this.$bvModal.hide('modal-edit')
            this.loading = false
            console.log('this.expenses', this.expenses)
            this.getBloodTransfusions()
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      } else {
        (this.params.form = this.EditForm),
        (this.params.path = `/bloodTransfusions/${this.EditForm.id}`),
        this.$store
          .dispatch('update', this.params)
          .then(response => {
            this.$bvModal.hide('modal-edit')
            this.loading = false
            this.getBloodTransfusions()
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      }
    },
    getTransfusionType(id) {
      const transfusionType = this.transfusionTypes
      console.log('transfusionType1111', transfusionType)

      if (id) {
        // console.log("id", id);
        const writeType = transfusionType.find(type => type.id === id)
        console.log('writeType', writeType)
        return writeType.name
      }

      //   return transfusionType;
    },
  },
}
</script>
<style lang="scss" scoped>
/* Collapse toggle button styles */
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

// Compact styles - no margins/padding
.compact-card {
  margin: 0;
  border: none;
}

.main-padding {
  padding: 1rem;
}

.compact-container {
  padding: 0.5rem;
}

.compact-row {
  margin: 0;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.compact-header {
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.compact-title {
  margin: 0;
}

.compact-filter-toggle {
  margin-bottom: 0.5rem;
}

.compact-filters-section {
  padding: 0.5rem 0;
}

.compact-filters {
  margin-bottom: 0.5rem;
}

.compact-col {
  padding: 0.25rem;
}

.compact-form-group {
  margin-bottom: 0.5rem;

  ::v-deep label {
    margin-bottom: 0.25rem;
  }
}

.compact-input {
  font-size: 0.875rem;
}

.compact-content-row {
  margin: 0.5rem 0;
}

.view-toggle-buttons {
  display: flex;
  align-items: center;
}

// Compact table
.compact-table {
  margin: 0;

  ::v-deep th,
  ::v-deep td {
    padding: 0.5rem 0.75rem;
  }

  ::v-deep thead th {
    font-weight: 600;
    padding: 0.5rem 0.75rem;
  }
}

// Blood transfusion card view styles - compact
.transfusion-cards-container {
  min-height: 150px;
  margin: 0;
}

.compact-card-col {
  padding: 0.25rem;
  margin: 0;
}

.compact-transfusion-card {
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin: 0;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .compact-card-header {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
    flex-shrink: 0;
  }

  .compact-transfusion-id {
    margin: 0;
  }

  .card-body-card {
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    height: 100% !important;
  }

  .compact-card-body {
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .compact-card-footer {
    border-top: 1px solid #f0f0f0;
    padding-top: 0.5rem;
    margin-top: auto;
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    flex-shrink: 0;
  }

  .transfusion-info-item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    gap: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      font-weight: 600;
      color: #666;
      margin-bottom: 0.15rem;
    }

    .info-value {
      color: #333;
      word-break: break-word;
    }
  }

  .compact-badge {
    font-size: 0.75rem;
  }

  .compact-action-button {
    flex: 1;
    min-width: fit-content;
    font-size: 0.8rem;
    padding: 0.375rem;
  }
}

// Empty state placeholder
.empty-state-card {
  padding: 2rem 1rem;
}

.empty-placeholder-card {
  border: 2px dashed #e0e0e0;
  background-color: #f8f9fa;
  padding: 3rem 2rem;
}

.empty-state-content {
  .empty-icon {
    color: #adb5bd;
    margin-bottom: 1rem;
  }
}

.compact-loading {
  padding: 1rem 0;
}

.compact-loading-text {
  margin: 0.5rem 0 0 0;
}

.compact-pagination {
  padding: 0.5rem;
  margin: 0;
}

.compact-pagination-row {
  margin: 0;
}

.compact-pagination-info {
  padding: 0.25rem;
}

.compact-pagination-text {
  font-size: 0.8rem;
}

.compact-pagination-controls {
  ::v-deep .page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
  }

  ::v-deep .page-item {
    margin: 0 0.1rem;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
